var map = {
	"./qr-apk-th-en-page.png": "6cbc",
	"./qr-apk-th-page.png": "61cf",
	"./staging-qr-apk-th-en-page.png": "4b87",
	"./staging-qr-apk-th-page.png": "208b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "77a1";